import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { MenuService } from '../../../services/menu.service';
import { LogService } from '../../../services/log.service';
import { TranslationService } from '../../../services/translation.service';
import { ConfigService } from '../../../services/config.service';
import { DataIoService } from '../../../services/data-io.service';
import { ValueChangedConfirmation } from '../../../classes/ValueChangedConfirmation';
import { Helper, MenuNode, BaseSensor, ISensorInterface } from '../../../classes';
import { IconBarService } from '../../../services/icon-bar.service';
import { NavBarService } from '../../../services/nav-bar.service';
@Component({
  selector: 'app-setup',
  templateUrl: './setup.component.html',
  styleUrls: ['./setup.component.scss']
})
export class SetupComponent implements OnInit {
	_saving = false;
	save(){
		this._saving = true;
		setTimeout( ()=>{
			this._saving = false;
		},1000);
	}
	_bigLetters:string='';
	_smallLetters:string='';
	_node :MenuNode=undefined;
	_subscription:any=undefined;
	_ptr:'gas'|'type'='gas';
    _sub_ptr :'skip'|'change'|'select'|'confirm'='skip';

	_items:Array<MenuNode>=undefined;
	_gases=[
		'nAt','LPG','5.1','5.2','5.3','6'
	];
	_types=[
		'0','1','C43.P','C10.3','C11.3','C12.3','C13.3','C14.3','8'
	];

    _gas = 0;
    _type = 0;
    _el=undefined;
    _savedGas = 0;
    _savedType = 0;

    updateUI(){
    	if(this._ptr == 'gas'){

    		if(this._sub_ptr=='skip'){
    			this.display('GAS',this.getCurrentGas());
    			return;
    		}

    		if(this._sub_ptr=='change'){
    			this.display('SEL','GAS');
                return;
    		}

    		if(this._sub_ptr=='select'){
    			this.display('GAS',this.getCurrentGas());
    			return;
    		}

    		if(this._sub_ptr=='confirm'){
    			this.display('SEt',this.getCurrentGas());
                this.menuService.disableButton('up');
                this.menuService.disableButton('down');
                this.menuService.disableButton('slider');
    			return;
    		}

    	}

		if(this._ptr == 'type'){
            if(this.isMCondens()){
                this.menuService.disableButton('back');
            }
    		if(this._sub_ptr=='skip'){
                this.menuService.undisableButton('up');
                this.menuService.undisableButton('down');
                this.menuService.undisableButton('slider');
    			this.display('tYPE',this.getCurrentType());
    			return;
    		}

    		if(this._sub_ptr=='change'){
    			this.display('SEL','tYPE');
                return;
    		}

    		if(this._sub_ptr=='select'){
    			this.display('tYPE',this.getCurrentType());
    			return;
    		}

    		if(this._sub_ptr=='confirm'){
    			this.display('SEt',this.getCurrentType());
                this.menuService.disableButton('up');
                this.menuService.disableButton('down');
                this.menuService.disableButton('slider');
    			return;
    		}

    	}
    }
    getCurrentGas(){
    	return this._gases[this._gas];
    }
    getCurrentType(){
    	return this._types[this._type];
    }
    
    display(smallLetters:string,bigLetters:string){
    	this._bigLetters = bigLetters;
    	this._smallLetters = smallLetters;
    }
    
    previous(){

    	if(this._sub_ptr == 'select'){
            if(this._ptr == 'gas'){
    			this._gas = (this._gases.length+(this._gas-1))%this._gases.length;
                return;
            }
            if(this._ptr == 'type'){
    			this._type = (this._types.length+(this._type-1))%this._types.length;
    			return;
            }
    	}
		if(this._sub_ptr == 'skip'){
			this._sub_ptr = 'change';
			return;
		}
		if(this._sub_ptr == 'change'){
			this._sub_ptr = 'skip';
		}
	
    	
    }
    next(){
    	if(this._sub_ptr == 'select'){
    		if(this._ptr == 'gas'){
    			this._gas = (this._gas+1)%this._gases.length;
    			return;
    		}
    		if(this._ptr == 'type'){
    			this._type = (this._type+1)%this._types.length;
    			return;
    		}
    	}	
		if(this._sub_ptr == 'skip'){
			this._sub_ptr = 'change';
			return;
		}
		if(this._sub_ptr == 'change'){
			this._sub_ptr = 'skip';
			return;
		}
	
    }

    confirm(){
    	if(this._sub_ptr == 'skip'){
    		if(this._ptr == 'gas'){
                if(!this.isMCondens()){
                    this.save();
                    setTimeout( ()=>{
                        this.menuService.goto('dashboard');
                    },900);
                    return;
                }
    			this._ptr = 'type';
    			return;
    		}
    		if(this._ptr == 'type'){
    			this.save();
                setTimeout( ()=>{
                    this.menuService.goto('dashboard');
                },900);
    		}
    	}
    	if(this._sub_ptr == 'change'){
    		this._sub_ptr = 'select';
    		return;
    	}
    	if(this._sub_ptr == 'select'){
    		this._sub_ptr = 'confirm';
    		return;
    	}


    	if(this._sub_ptr == 'confirm'){
    		this._sub_ptr = 'skip';
    		if(this._ptr == 'gas'){
    			if(this._savedGas != this._gas){
    				this.save();
    			}
    			this._ptr = 'type';
    			return;
    		}
			if(this._ptr == 'type'){
				if(this._savedType != this._type){
    				this.save();
    				setTimeout( ()=>{
    					this.menuService.goto('dashboard');
    				},900);
    			
    			}else{
    				this.menuService.goto('dashboard');
    			}
    			return;
			}
    	}
    }

    back(){
    	if(this._ptr == 'gas'){
    		if(this._sub_ptr == 'skip'){
    			this.menuService.hierarchyUp(true,undefined);
    			return;
    		}
    		if(this._sub_ptr == 'change'){
    			this._sub_ptr = 'skip';
    			return;
    		}
    	}
    	if(this._ptr == 'type' && ['skip','change'].includes(this._sub_ptr) ){
    		this._ptr = 'gas';
    		this._sub_ptr = 'skip';
    		return;
    	}
    	if(this._sub_ptr == 'confirm'){
    		this._sub_ptr = 'select';
    		return;
    	}
    	if(this._sub_ptr == 'select'){
    		this._sub_ptr = 'skip';
    		return;
    	}

    }
	b():string{
		if(this._saving){
			return '';
		}
		return this._bigLetters;	
	}
	s():string{
		if(this._saving){
			return '';
		}
		return this._smallLetters;	
	}
    constructor(
        private menuService: MenuService, 
        private ioService: DataIoService, 
        private logger: LogService, 
        private config: ConfigService, 
        private translator:TranslationService,
        private navBar:NavBarService,
        private iconBar:IconBarService) {
        
        this._subscription = this.ioService.inputs.events$.subscribe( (evt)=>{
        	this.eventHandler(evt);
        });
        if(this.isCountry('fr')){
            this._savedType = 4;
            this._type = 4;
            console.log("Country is france.");
        }
        if(this.isCountry('it')){
            this._savedType = 3;
            this._type = 3;
            console.log("Country is italy.");
        }
        console.log("Variant: "+this.ioService.getConfiguration().simulatorConfig.getVariant());
        if(this.isMCondens()){
            this._ptr = 'type';
            console.log("isMcondens.");
        }

    }
    isMCondens():boolean{
        return ['IsoTwinMCondens','ThemaFastMCondens','ThemaMCondens'].includes(this.ioService.getConfiguration().simulatorConfig.getVariant());
    }
    isCountry(c:string):boolean{
        return (this.ioService.getConfiguration().simulatorConfig.getCountry() == c);
    }

    ngOnInit(){
    	this._node = this.menuService.getCurrentNode();
        
    	this.updateUI();
    }
    ngOnDestroy() {
    	if(this._subscription){
    		this._subscription.unsubscribe();
    	}

    }

    eventHandler(event:string){
    	if(this._saving){
    		return;
    	}
    	switch(event){
    		case 'down':{
    			this.previous();
    			this.updateUI();
    			return;
    		}
    		case 'up':{
    			this.next();
    			this.updateUI();
    			return;
    		}
    		case 'confirm':{
    			this.confirm();
                console.log("PTR: "+this._ptr);
                console.log("SUBPTR: "+this._sub_ptr);
    			this.updateUI();
    			return;
    		}
    		case 'back':{
    			this.back();
    			this.updateUI();
    			return;
    		}
    	}
    }
}


